import { useDispatch } from "react-redux";
import { setPopularMovies } from "../utils/store/slice/movieSlice";
import { TMDBOptions } from "../utils/tmdbOption";
import { useEffect } from "react";

const UsePopularMovies = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    fetch(
      `https://api.themoviedb.org/3/movie/popular?language=en-US&page=1`,
      TMDBOptions
    )
      .then((res) => res.json())
      .then((data) => {
        dispatch(setPopularMovies(data.results));
      });
  };
};

export default UsePopularMovies;
